import React, { PropsWithChildren, useMemo } from 'react'

import TripConditions from '@components/TripInfo/TripConditions'
import fareClassUtils from '@lib/fareClass'
import featureUtils from '@lib/fareFeature'

interface FareDetailsProps {
  fareClass: string
  carriers: MarketingCarrier[]
}

const FareDetails: React.FC<PropsWithChildren<FareDetailsProps>> = ({ fareClass, carriers, children }) => {
  const resolvedFareClass: FareClass | undefined = useMemo(
    () => (fareClass ? fareClassUtils.getFareClassByCode(fareClass, carriers) : undefined),
    [fareClass, carriers],
  )

  const filteredFareFeatures = useMemo(
    () =>
      resolvedFareClass &&
      resolvedFareClass.fareFeatures.filter(
        (feature: FareFeature) => featureUtils.hasRefundFeatures(feature) || featureUtils.isMobileWalletOnly(feature),
      ),
    [resolvedFareClass],
  )

  if (!resolvedFareClass) return null

  return (
    <>
      {children}
      <div data-tag="fare-details">
        <h5 className="mb-2">{resolvedFareClass?.name}</h5>
        <TripConditions fareFeatures={filteredFareFeatures} />
      </div>
    </>
  )
}

export default FareDetails
